import React from 'react';
import { Spin } from 'antd';

const Spinner = ( { topMargin = '200' } ) => {
    return (
        <Spin 
            size="medium"
            style={ { marginTop: `${ topMargin }px` } }    
        />
    );
};

export default Spinner;
